<div class="screen-container">
  <div>
    <app-card
      [title]="
        (!success ? 'unsubscribe.title' : 'unsubscribe.successTitle')
          | translate
      "
    >
      <div left-content>
        <ng-template [ngTemplateOutlet]="unsubscribeBlock"></ng-template>
      </div>
      <div right-content>
        <app-contact></app-contact>
      </div>
    </app-card>
  </div>
</div>

<ng-template #unsubscribeBlock>
  <form *ngIf="!success" [formGroup]="unsubscribeForm">
    <div content class="content-container">
      <div class="input-container">
        <div class="input-container">
          <app-input
            [label]="'unsubscribe.phoneNumber'"
            [control]="phoneNumber"
            [error]="getErrors('phoneNumber')"
            [inputMode]="'tel'"
            [type]="'text'"
            [icon]="'phone'"
          ></app-input>
        </div>
      </div>
    </div>
    <div class="button-container">
      <button
        mat-flat-button
        color="primary"
        (click)="handleButtonClick()"
        [ngClass]="{ fullWidth: true }"
      >
        {{ "unsubscribe.buttonText" | translate }}
        <span *ngIf="isLoading" class="icon icon-loading"></span>
      </button>
    </div>
    <div class="error">{{ error }}</div>
  </form>
  <ng-template
    *ngIf="success && !isLoading"
    [ngTemplateOutlet]="unsubscribeSuccessful"
  ></ng-template>
</ng-template>

<ng-template #unsubscribeSuccessful>
  <div *ngIf="success" class="text-container">
    <div class="w4rAnimated_checkmark">
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 130.2 130.2"
      >
        <circle
          class="path circle"
          fill="none"
          stroke="#73AF55"
          stroke-width="6"
          stroke-miterlimit="10"
          cx="65.1"
          cy="65.1"
          r="62.1"
        />
        <polyline
          class="path check"
          fill="none"
          stroke="#73AF55"
          stroke-width="6"
          stroke-linecap="round"
          stroke-miterlimit="10"
          points="100.2,40.2 51.5,88.8 29.8,67.5 "
        />
      </svg>
    </div>

    <h2 class="center">
      {{
        "unsubscribe.unsubscribed.success"
          | translate: { phoneNumber: phoneNumber.value }
      }}
    </h2>
  </div>
</ng-template>
